export class MaximumNumberOfTurnaroundsReachedError extends Error {
  constructor() {
    super('The maximum number of turnarounds has been reached.')
    Object.setPrototypeOf(this, MaximumNumberOfTurnaroundsReachedError.prototype)
  }
}
